import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';

export default class OutroScene extends Scene {
	constructor() {
		super();

		this.timeouts = [];
	}

	init() {
		super.init();

		common.t.track('game complete event', {gamelevel: common.currentLevel, gamecomplete: 1});

		let endScreen = new PIXI.Sprite(P3.assets.texture('endgame'));
		endScreen.anchor.set(0.5);
		endScreen.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(endScreen);

		let header = Text('// ', {font: '48px Title', align: 'center'});
		header.tint = 0xFFFFFF;
		header.maxWidth = 420;
		header.anchor.set(0.5, 0);
		header.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 90);
		this.addChild(header);

		let body = Text(translate('OUTRO.BODY'), {font: '24px Ahkio Thin', align: 'center'});
		body.tint = 0xFFFFFF;
		body.maxWidth = 400;
		body.alpha = 0;
		body.anchor.set(0.5, 0);
		body.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 40);
		this.addChild(body);

		const text = translate('OUTRO.HEADER');
		const addTitleLetter = (time, letter) => {
			const timeout = setTimeout(() => {
				if (header.text.length === 1) {
					P3.audio.playSound('sfx_terminal_typing_00');
				}

				if (letter) {
					header.text += letter;
				}
			}, time);

			this.timeouts.push(timeout);
		};

		addTitleLetter(0, null);

		for (let i = 0; i < text.length; i++) {
			addTitleLetter(1000 + (i * 100), text[i]);
		}

		const delay = (1200 + (text.length * 100)) / 1000;
		P3.utils.delay(delay, () => {
			this.flashCaret(header.children[header.children.length - 1]);

			new P3.utils.TWEEN.Tween(body, this.tweens)
				.to({alpha: 1}, 300)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.start();
		});

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_large_out');
		states.over = P3.assets.texture('ui_btn_large_over');
		states.down = P3.assets.texture('ui_btn_large_down');
		states.icon = P3.assets.texture('ui_icon_play');

		let playButton = new P3.Button(states);
		playButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 200);
		playButton.signals.click.add(() => {
			this.signals.next.dispatch();
		}, this);
		playButton.scale.set(2);
		playButton.visible = false;
		this.addChild(playButton);

		new P3.utils.TWEEN.Tween(playButton.scale, this.tweens)
			.to({x: 1, y: 1}, 150)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.delay(4000)
			.onStart(() => {
				playButton.visible = true;
			})
			.start();
	}

	flashCaret(letter) {
		new P3.utils.TWEEN.Tween(letter, this.tweens)
			.to({alpha: 0}, 1)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.yoyo(true)
			.repeat(Infinity)
			.delay(500)
			.start();
	}

	destroy() {
		for (let i = 0; i < this.timeouts.length; i++) {
			clearTimeout(this.timeouts[i]);
		}

		super.destroy();
	}

	update() {
		super.update();
	}
}
